module.exports = __webpack_public_path__ + "img/item2.4a35e6e4.png";